import { Plan, AiPlan } from 'src/types/pricing.types';
const assetsUrl = process.env.NEXT_PUBLIC_SHARED_CDN_URL;

const featureWordsList = [
  '120 iStock Media',
  '1M\\+',
  'Unlimited',
  '1080p',
  '10 GB',
  'Reseller',
  '15min',
  'Full Access',
  'All-access',
  'Standard',
  '100\\+',
  '60',
  '10 iStock',
  '10GB',
  // '5000\\+',
  '20 ',
  '40 ',
  '120 iStock',
  '4000\\+',
  'Create and save',
  'Upload',
];

const featuresRegex = new RegExp('^(' + featureWordsList.join('|') + ')');

export const getRichFeatureText = (
  feature: string,
): { text: string; prefix?: string } => {
  const splitFeature = feature.split(featuresRegex);
  if (splitFeature.length === 3) {
    return {
      prefix: splitFeature[1],
      text: splitFeature[2],
    };
  } else {
    return { text: feature };
  }
};

export const INITIAL_PLANS: Plan[] = [
  {
    name: 'FREE',
    description: 'For anyone who wishes to try InVideo',
    planPrice: {
      monthly: {
        currency: '$',
        price: 0,
        subText: '',
      },
      annually: {
        currency: '$',
        price: 0,
        subText: '',
      },
    },
    CTA: {
      monthly: {
        text: 'Start now',
        url: `/workflow/marketing-templates`,
        backgroundColorClass: 'iv-bg-grey-100',
        textColorClass: 'iv-text-10',
      },
      annually: {
        text: 'Start now',
        url: `/workflow/marketing-templates`,
        backgroundColorClass: 'iv-bg-grey-100',
        textColorClass: 'iv-text-10',
      },
    },
    feature: [],
    featuresCheckImage: ``,
    redirection: {
      url: `/workflow/marketing-templates`,
      type: 'internal',
      modal: true,
    },
    currency_symbol: '$',
    features: [],
    id: 1,
    key_features: [],
    label: 'Free',
    rank: 0,
    tagline: '',
    durations: [],
  },
  {
    name: 'BUSINESS',
    description: 'For small business, educators and influencers',
    bannerText: 'Popular',
    planPrice: {
      monthly: {
        currency: '$',
        price: 30,
        subText: '/ mo*',
        starText: '*Billed monthly until cancelled',
      },
      annually: {
        currency: '$',
        price: 15,
        subText: '/ mo*',
        starText: '*Billed $180 annually',
      },
    },
    CTA: {
      monthly: {
        text: 'Get Business',
        url: `/pricing`,
        backgroundColorClass: 'iv-bg-blue',
        textColorClass: 'iv-text-blue',
      },
      annually: {
        text: 'Get Business',
        url: `/pricing`,
        backgroundColorClass: 'iv-bg-blue',
        textColorClass: 'iv-text-blue',
      },
    },
    feature: [],
    appPromo: {
      firstLine: 'Get Filmr Pro ',
      secondLine: 'Mobile app',
      CTAText: 'Read more',
      backgroundGradientClass: 'iv-gradient-raspberry-deep-blue-blue',
      appImage: ``,
    },
    featuresCheckImage: ``,
    redirection: {
      url: `/pricing`,
      type: 'internal',
      modal: true,
    },
    currency_symbol: '$',
    features: [],
    id: 1,
    key_features: [],
    label: 'Business',
    rank: 0,
    tagline: '',
    durations: [],
  },
  {
    name: 'UNLIMITED',
    description: 'For agencies and multiple teams',
    planPrice: {
      monthly: {
        currency: '$',
        price: 60,
        subText: '/ mo*',
        starText: '*Billed monthly until cancelled',
      },
      annually: {
        currency: '$',
        price: 30,
        subText: '/ mo*',
        starText: '*Billed $360 annually',
      },
    },
    CTA: {
      monthly: {
        text: 'Get Unlimited',
        url: `/pricing`,
        backgroundColorClass: 'iv-bg-violet',
        textColorClass: 'iv-text-violet',
      },
      annually: {
        text: 'Get Unlimited',
        url: `/pricing`,
        backgroundColorClass: 'iv-bg-violet',
        textColorClass: 'iv-text-violet',
      },
    },
    feature: [],
    appPromo: {
      firstLine: 'Get Filmr Pro ',
      secondLine: 'Mobile app',
      CTAText: 'Read more',
      backgroundGradientClass: 'iv-gradient-raspberry-violet',
      appImage: ``,
    },
    featuresCheckImage: ``,
    redirection: {
      url: `/pricing`,
      type: 'internal',
      modal: true,
    },
    currency_symbol: '$',
    features: [],
    id: 1,
    key_features: [],
    label: 'Unlimited',
    rank: 0,
    tagline: '',
    durations: [],
  },
];

export const AI_INITIAL_PLANS: AiPlan[] = [
  // {
  //   name: 'Free',
  //   key: 'free',
  //   sequence: 1,
  //   description: {
  //     desktop: 'For anyone who wishes to try AI video creation',
  //     mobile: 'Try AI video creation',
  //   },
  //   planPrice: {
  //     monthly: {
  //       currency: '$',
  //       price: 0,
  //       planId: 'free_monthly_usd',
  //     },
  //     yearly: {
  //       currency: '$',
  //       price: 0,
  //       planId: 'free_yearly_usd',
  //     },
  //   },
  //   CTA: {
  //     text: 'Try for free',
  //     url: `/workflow/marketing-templates`,
  //     backgroundColorClass: 'iv-bg-grey-100',
  //     textColorClass: 'iv-text-10',
  //   },
  //   redirection: {
  //     url: `/workflow/marketing-templates`,
  //     type: 'internal',
  //     modal: true,
  //   },
  //   currency_symbol: '$',
  //   key_features: [],
  //   usageQuota: {},
  // },
  {
    name: 'Plus',
    subText: 'best for stock video',
    key: 'plus',
    sequence: 2,
    description: {
      desktop: 'For creators starting their journey',
      mobile: 'Creators starting their journey ',
    },
    planPrice: {
      monthly: {
        currency: '$',
        price: 0,
        planId: 'plus_monthly_usd',
      },
      yearly: {
        currency: '$',
        price: 0,
        planId: 'plus_yearly_usd',
      },
    },
    CTA: {
      text: 'Get Plus',
      url: `/pricing`,
      backgroundColorClass: 'iv-bg-blue',
      textColorClass: 'iv-text-blue',
    },

    redirection: {
      url: `/pricing`,
      type: 'internal',
      modal: true,
    },
    currency_symbol: '$',
    key_features: [],
    usageQuota: {},
  },
  {
    name: 'Max',
    subText: 'best for stock video',
    key: 'max',
    sequence: 2,
    description: {
      desktop: 'For growing & established creators',
      mobile: 'For growing & established creators',
    },
    planPrice: {
      monthly: {
        currency: '$',
        price: 0,
        planId: 'max_monthly_usd',
      },
      yearly: {
        currency: '$',
        price: 0,
        planId: 'max_yearly_usd',
      },
    },
    CTA: {
      text: 'Get Max',
      url: `/pricing`,
      backgroundColorClass: 'iv-bg-violet',
      textColorClass: 'iv-text-violet',
    },
    redirection: {
      url: `/pricing`,
      type: 'internal',
      modal: true,
    },
    currency_symbol: '$',
    key_features: [],
    usageQuota: {},
  },
  {
    name: 'Generative',
    subText: 'best for ads and films',
    key: 'generative',
    sequence: 3,
    description: {
      desktop: '',
      mobile: '',
    },
    planPrice: {
      monthly: {
        currency: '$',
        price: 0,
        planId: 'generative_monthly_usd',
      },
      yearly: {
        currency: '$',
        price: 0,
        planId: 'generative_yearly_usd',
      },
    },
    CTA: {
      text: 'Get Generative',
      url: `/pricing`,
      backgroundColorClass: 'iv-bg-violet',
      textColorClass: 'iv-text-violet',
    },
    redirection: {
      url: `/pricing`,
      type: 'internal',
      modal: true,
    },
    currency_symbol: '$',
    key_features: [],
    usageQuota: {},
  },
  {
    name: 'Team',
    subText: 'best for teams',
    key: 'team',
    sequence: 4,
    description: {
      desktop: 'For growing & established creators',
      mobile: 'For growing & established creators',
    },
    planPrice: {
      monthly: {
        currency: '$',
        price: 0,
        planId: 'team_monthly_usd',
      },
      yearly: {
        currency: '$',
        price: 0,
        planId: 'team_yearly_usd',
      },
    },
    CTA: {
      text: 'Get Team',
      url: `/pricing`,
      backgroundColorClass: 'iv-bg-violet',
      textColorClass: 'iv-text-violet',
    },
    redirection: {
      url: `/pricing`,
      type: 'internal',
      modal: true,
    },
    currency_symbol: '$',
    key_features: [],
    usageQuota: {},
  },
];

export const PLANS_SPECIAL_FEATURES = [
  {
    key: 'video-edit',
    title: 'Free video editor',
    icon: '/pricing/video-edit.svg',
    aiBadge: false,
  },
  {
    key: 'first-cut',
    title: 'AI generated first-cuts',
    icon: '/pricing/first-cut.svg',
    aiBadge: true,
  },
  {
    key: 'stock',
    title: '16mn+ stock media',
    icon: '/pricing/stock.svg',
    aiBadge: false,
  },
  {
    key: 'voiceover',
    title: 'Realistic AI voiceovers',
    icon: '/pricing/voiceover.svg',
    aiBadge: true,
  },
];

export const PLANS_FEATURES_ORDER = [
  'exports',
  'premium_generation_minutes',
  'storage',
  'istock',
  'unlimited_standard_stock',
  'video_resolution',
  'user_data',
  'voice',
];

export const PLANS_FEATURES_DISPLAY_NAME: { [key: string]: string } = {
  exports: 'Exports',
  premium_generation_minutes: 'Premium generation',
  storage: 'Storage',
  istock: 'iStock quota',
  unlimited_standard_stock: 'Unlimited standard stock',
  free_editor: 'Free editor',
  video_resolution: 'Video resolution',
  user_data: 'User data',
  voice: 'Voice Clones',
};

export const CHECKOUT_RELATIVE_URL = '/payments/checkout';
